import { LinkField, LinkType, PrismicDocument } from '@prismicio/client';
import { SupportCategory } from './support-types';
import { urlifyTitle } from './urlify-title';

export const transformSupportDocLink = (category: PrismicDocument<SupportCategory>) =>
  <LinkField>{
    link_type: LinkType.Document,
    slug: `${category.id}-${urlifyTitle(category.data.title)}`,
  };
